import React, { FunctionComponent } from 'react';

import { default as MuiMenuList, MenuListProps } from '@mui/material/MenuList';

const MenuList: FunctionComponent<MenuListProps> = ({
  children,
  sx,
}: MenuListProps) => {
  return <MuiMenuList sx={sx}>{children}</MuiMenuList>;
};

export default MenuList;
